import { createAction } from '@reduxjs/toolkit';

export const requestCreatePost = createAction('request/createPost');
export const requestViewPosts = createAction('request/viewPosts');
export const requestUpdatePost = createAction('request/updatePost');
export const requestDeletePost = createAction('request/deletePost');
export const requestSearchPosts = createAction('request/searchPosts');
export const requestViewPostHierarchy = createAction('request/viewPostHierarchy');
